import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import type Intl from 'ember-intl/services/intl';

type Positional = [string | undefined];
type Named = {
  nestedPath?: string;
  defaultToBlank?: boolean;
};

export interface SafeTSignature {
  Args: {
    Positional: Positional;
    Named: Named;
  };
  Return: string | undefined;
}

/**
 * Returns the translation or the original key when missing. defaultToBlank uses an empty fallback;
 * nestedPath prefixes only the lookup, preserving the original key fallback.
 */
export default class SafeT extends Helper<SafeTSignature> {
  @service declare intl: Intl;

  compute([translationKeyString]: [string], { nestedPath = '', defaultToBlank = false }) {
    const prefix = nestedPath ? `${nestedPath}.` : '';

    const translationKey = `${prefix}${translationKeyString}`;

    if (this.intl.exists(translationKey, 'en-us')) {
      return this.intl.t(translationKey);
    }

    return defaultToBlank ? '' : translationKeyString;
  }
}
